import styled from "styled-components";

export const SellNftTitle = styled.p`
  color: black;
`;

export const Label = styled.label`
  color: black;
  margin-top: 2rem;
`;

export const MainSellComponent = styled.div`
  position: relative;

  & .service {
    display: flex;
    color: black;
    justify-content: space-between;
    margin-top: 0.5rem;
  }

  & .sellNftMain {
    display: flex;
    gap: 0.5rem;
  }

  & .sellNftMain .leftArrow {
    margin-right: 0.5rem;
    cursor: pointer;
  }

  & .sellNftMain .nftTitle,
  .nftDetails {
    color: black;
  }
  & .sellNftMain .nftDetails {
    margin-top: -0.5rem;
  }
`;
